﻿import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import notify from '../../shared/feedback/notifications';
import { Translate } from '../../shared/LanguageService';
import { handleError } from '../../shared/ErrorCatching';
import AutoUpdateListTrigger from '../../shared/AutoUpdateListTrigger';
import * as imageEditorsActions from './ImageEditorsActions';
import ImageEditorsList from './ImageEditorsList';
import ImageEditorUserModal from './ImageEditorUserModal';

class ImageEditorsPage extends React.Component<any, any> {
    private _updateListTrigger: AutoUpdateListTrigger;

    constructor(props: any) {
        super(props);

        this.state = {
            editId: 0,
            shouldShowModal: false,
            isLoading: false
        };

        this.deleteUser = this.deleteUser.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.openAddUserModal = this.openAddUserModal.bind(this);
        this.openEditUserModal = this.openEditUserModal.bind(this);
        this.getListImageEditors = this.getListImageEditors.bind(this);

        this._updateListTrigger = new AutoUpdateListTrigger(this.getListImageEditors);
    }

    componentDidMount() {
        this.getListImageEditors();
        this._updateListTrigger.subscribe();
    }

    componentWillUnmount() {
        this._updateListTrigger.unsubscribe();
    }

    getListImageEditors() {
        if (!this.state.isLoading) {
            this.setState({ isLoading: true });
            this.props.actions
                .listImageEditors()
                .then(() => {
                    this.setState({ isLoading: false });
                })
                .catch((errorResponse: any) => {
                    this.setState({ isLoading: false });
                    errorResponse.errors.forEach((e: any) => {
                        notify.failure(e.value);
                    });
                });
        }
    }

    openEditUserModal(id: number) {
        this.setState({ editId: id });
        this.toggleModal();
    }

    openAddUserModal() {
        this.setState({ editId: 0 });
        this.toggleModal();
    }

    toggleModal() {
        this.setState({ shouldShowModal: !this.state.shouldShowModal });
    }

    render() {
        return (
            <div>
                <h1>{Translate('image-editors/page/title/image-editors')}</h1>

                <Button
                    bsSize="large"
                    className="pull-right"
                    onClick={this.openAddUserModal}
                    bsStyle="success"
                >
                    {Translate('image-editors/page/button-label/add-image-editor')}
                </Button>
                {this.state.shouldShowModal && (
                    <ImageEditorUserModal
                        editId={this.state.editId}
                        shouldShowModal={this.state.shouldShowModal}
                        closeModal={this.toggleModal}
                    />
                )}
                <ImageEditorsList
                    imageEditors={this.props.list}
                    deleteUser={this.deleteUser}
                    editUser={this.openEditUserModal}
                />
            </div>
        );
    }

    deleteUser(id: number) {
        this.props.actions
            .deleteImageEditorUser(id)
            .then(() => {
                notify.success(Translate('image-editors/notification/user-deleted'));
            })
            .catch((error: any) => handleError(error));
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        list: state.imageEditors.list.sort((a: any, b: any) => {
            return a.id - b.id;
        }),
        emptyUserInput: {
            id: -1,
            username: '',
            name: '',
            email: '',
            phoneNumber: '',
            languageKey: ''
        }
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            listImageEditors: () => dispatch(imageEditorsActions.getImageEditors()),
            deleteImageEditorUser: (id: number) =>
                dispatch(imageEditorsActions.deleteImageEditorUser(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ImageEditorsPage));
